import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import ErrorRecordTable from "../utils/ErrorRecordTable";

function ErrorRecords({ data }) {
  const { FILE_NAME = "", errorRecords = [] } = data;

  return (
    <>
      <Box sx={{ margin: "-10px 0 10px" }}>
        <span style={{ fontWeight: "bolder" }}>File Location - </span>
        {FILE_NAME}
      </Box>
      <Paper elevation={2} sx={{ maxWidth: "100%", overflow: "hidden" }}>
        <ErrorRecordTable data={errorRecords} tableMaxHeight="500px" />
      </Paper>
    </>
  );
}

ErrorRecords.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default ErrorRecords;
